export const typeContrat = [
    "CDI", "CDD", "Freelance"
];

export const MAX_SIZE = 5 * 1024 * 1024;
export const VALIDEXTENSIONS = [
    ".pdf", ".doc", ".docx", ".odt"
];